import { defineAsyncComponent } from "vue";
import type { App } from "vue";
/*
 **全局注册组件
 */
const components: object = import.meta.glob("./global/*/*.vue"); // 异步方式
export default function install(app: App) {
  for (const [key, value] of Object.entries(components)) {
    const name = key.slice(key.lastIndexOf("/") + 1, key.lastIndexOf("."));

    app.component(`Csd${name}`, defineAsyncComponent(value));
  }
}
